import { Method } from "axios";
import { BaseRequest } from "./base-request";
import { ComputationQuery } from "../models/request/computation-query";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { ComputationResult } from "../models/response/computation-result";
import { RequestModelInterface } from "../models/request-model-interface";

export class ComputationRequest extends BaseRequest
{
    protected computation: ComputationQuery;

    public constructor(computation: ComputationQuery)
    {
        super();

        this.computation = computation;
    }

    public get queryId(): string
    {
        return this.computation.queryId;
    }

    protected getMethod(): Method
    {
        return "POST";
    }

    protected getUri(): string
    {
        return `/computation`;
    }

    protected getData(): RequestModelInterface|null
    {
        return this.computation;
    }

    protected populateResponse(elem: XmlElementWrapper): ComputationResult
    {
        return ComputationResult.makeFromXml(elem);
    }
}
